import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ProjetoFonteRecurso } from '../../../models/projeto-fonte-recurso.model';
import { ProjetoFonteRecursoService } from '../../../services/projeto-fonte-recurso.service';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-projeto-fonte-recurso-edit',
  templateUrl: './projeto-fonte-recurso-edit.component.html',
  styleUrls: ['./projeto-fonte-recurso-edit.component.scss']
})
export class ProjetoFonteRecursoEditComponent 
  extends BaseFormComponent<ProjetoFonteRecurso>
  implements OnInit{

    actionLabel: string = 'Novo';

    constructor(
      private myService: ProjetoFonteRecursoService,
      public activatedRoute: ActivatedRoute,
      private navigation: NavigationService
    ) {
      super(activatedRoute);
    }

    ngOnInit(): void {
      this.loaded();
      this.initForm();
    }

    initForm() {
      this.form = new FormGroup({
        name: new FormControl('', [
          Validators.required,
          Validators.maxLength(255),
        ]),
      });
  
      if (this.entity) {
        this.actionLabel = 'Editar';
        this.form.patchValue(this.entity);
      }
    }

    voltar() {
      this.navigation.back(['pre-projeto/admin/projeto-fonte-recurso']);
    }

    getDataCreate(): ProjetoFonteRecurso {
      let data: ProjetoFonteRecurso;
      data = Object.assign({}, data, this.form.value);
      return data;
    }
  
    salvar(): void {
      if (this.form.valid) {
        this.loading();
        if (this.entity?.id) {
          this.addSub(
            this.myService
              .update(this.getDataCreate(), this.entity?.id)
              .subscribe({
                next: (res: ProjetoFonteRecurso) => {
                  this.msgSuccess('Cadastro alterado com sucesso!');
                  this.loaded();
                },
                error: (error) => {
                  this.msgError(error?.error.message);
                  this.loaded();
                },
              })
          );
        } else {
          this.addSub(
            this.myService.create(this.getDataCreate()).subscribe({
              next: (res: ProjetoFonteRecurso) => {
                this.msgSuccess('Cadastro criado com sucesso!');
                this.navigation.replace([
                  'pre-projeto/admin/projeto-fonte-recurso/',
                  res.id,
                ]);
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error.message);
                this.loaded();
              },
            })
          );
        }
      } else {
        this.markAsDirty();
      }
    }

    confirmExcluir() {
      this.alertConfirmation().subscribe((confirmed) => {
        if (confirmed) {
          this.excluir();
        }
      });
    }
  
    excluir(): void {
      this.loading();
      this.myService.delete(this.entity?.id).subscribe({
        next: (res) => {
          this.confirmation('Deletado com sucesso').subscribe(() => {
            this.navigation.replace(['pre-projeto/admin/projeto-fonte-recurso']);
          });
        },
        error: (error) => {
          this.loaded();
          this.msgError(error?.error.message);
        },
      });
    }

}
